<div class="upper-grid">
    <div class="flex justify-content-end">{{ 'voucher.situationDP.address' | translate }}:</div>
    <div class="fr-2 font-semibold">{{ store2.address() | formatAddress }}</div>

    <div class="flex justify-content-end">{{ 'voucher.situationDP.anotherInhabitants' | translate }}:</div>
    <app-radio-yes-no-input [form]="form" id="anotherInhabitants"></app-radio-yes-no-input>

    <app-multi-select-input
        [form]="form"
        id="contacts"
        valueKey="id"
        [staticOptions]="store2.contacts()"
        label="voucher.situationDP.selectContacts"
    >
        <ng-template #item let-item>
            <div class="flex-column gap-xx-small">
                <div>{{ item | formatPersonContact }}</div>
                @if (item.user.name?.length) {
                    <div class="font-size-x-small text-secondary">{{ item.user.email }}</div>
                }
            </div>
        </ng-template>
        <ng-template #selectedItems let-items>
            @if (items && items.length) {
                <div class="flex gap-small">
                    @for (item of items; track $index) {
                        <p-chip [label]="item | formatPersonContact"></p-chip>
                    }
                </div>
            } @else {
                {{ 'voucher.messages.noContacts' | translate }}
            }
        </ng-template>
    </app-multi-select-input>

    <div class="flex justify-content-end">{{ 'voucher.situationDP.inCare' | translate }}:</div>
    <app-radio-yes-no-input [form]="form" id="inCare"></app-radio-yes-no-input>
    <div></div>

    <div class="flex justify-content-end">{{ 'voucher.situationDP.mobility.label' | translate }}:</div>
    <app-radio-input [form]="form" id="mobility" [staticOptions]="partialOptions"></app-radio-input>
    <app-text-input [form]="form" id="mobilityDesc"
        label="voucher.situationDP.mobility.description"></app-text-input>

    <div class="flex justify-content-end">{{ 'voucher.situationDP.senseDisability' | translate }}:</div>
    <app-radio-yes-no-input [form]="form" id="senseDisability"></app-radio-yes-no-input>
    <app-text-input [form]="form" id="senseDisabilityDesc"
        label="voucher.situationDP.senseDescription"></app-text-input>

    <div class="flex justify-content-end">{{ 'voucher.situationDP.selfServiceAbility' | translate }}:</div>
    <app-radio-input [form]="form" id="selfServiceAbility" [staticOptions]="partialOptions"></app-radio-input>
    <app-text-input [form]="form" id="selfServiceAbilityDesc"
        label="voucher.situationDP.selfServiceDescription"></app-text-input>
</div>
<div class="bottom-grid mt-5">
    <div>{{ 'voucher.situationDP.medication' | translate }}:</div>
    <div>{{ 'voucher.situationDP.info' | translate }}:</div>
    <div>{{ 'voucher.situationDP.goal' | translate }}:</div>

    <app-input-wysiwyg
        id="medication"
        editorKey="VoucherDetailSituationDPMedication"
        [form]="form"
        [height]="300"
        [autocompleteOrganization]="true"
    ></app-input-wysiwyg>
    <app-input-wysiwyg
        id="info"
        editorKey="VoucherDetailSituationDPInfo"
        [class]="{'fh-2': folderStore.canEdit() }"
        [form]="form"
        [height]="folderStore.canEdit() ? 340 : 300"
        [autocompleteOrganization]="true"
    ></app-input-wysiwyg>
    <app-input-wysiwyg
        id="goal"
        editorKey="VoucherDetailSituationDPGoal"
        [form]="form"
        [height]="300"
        [autocompleteOrganization]="true"
    ></app-input-wysiwyg>

    @if (folderStore.canEdit()) {
        <app-button styleClass="w-full" label="voucher.situationDP.addMedication"
            (clickEvent)="addMedication()"></app-button>
        <app-button styleClass="w-full" label="voucher.situationDP.addDiagnosis"
            (clickEvent)="addDiagnosis()"></app-button>
    }
</div>

<ng-template #placeholderTemplate>
    {{ 'voucher.messages.noContacts' | translate }}
</ng-template>
